export enum StorageKey {
    USER_TOKEN = "userToken",
    IDENTITY = "identity"
}